import{useRef as t,useEffect as r}from"react";function n(n,o){const c=t(!1);r((()=>{c.current&&"function"==typeof n?n():c.current=!0}),[n,o])}export{n as default};
